import IconButton from '@mui/material/IconButton';
import { useState  } from 'react';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { Tooltip } from '@mui/material';
import { setAiDialogDetails } from 'app/store/aiChatSlice';
import { useSelector, useDispatch } from 'react-redux';
import { setSubscriptionExceededMessage } from 'app/store/subscriptionPlanSlice';
import { selectSubscriptionStatus } from 'app/store/userSlice';





export default function AIChatButton({ channelId, folderId, fileId, clientId, agentName, tooltip }) {
  const dispatch= useDispatch();
  const [show, setShow] = useState(false);
  const useTooltip= tooltip ? tooltip : "Open AI chat dialog.";
  const subscriptionStatus= useSelector(selectSubscriptionStatus);
  const subscription= subscriptionStatus?.subscription;
  const isEnabled= subscription?.featureFlags?.AIAgentCredits == "Enabled" || subscription?.featureFlags?.AIAgentCredits == "Limited";


  const handleClick = (event) => {
    setShow(false);
    
    if (isEnabled)
       //Only one of channel, file, folder, or client id should be set
       dispatch(setAiDialogDetails({channelId: channelId, folderId: folderId, fileId: fileId, clientId: clientId, agentName: agentName}));
    else
       dispatch(setSubscriptionExceededMessage("The AI chat feature requires a paid subscription plan."));
   
  };



  return (
	<Tooltip title={useTooltip} 
	    open={show} 
        disableHoverListener
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}> 
    <div>
      <IconButton
        onClick={handleClick}
        className='w-40 h-40'
        size="large"
      >
        <FuseSvgIcon>material-outline:auto_awesome</FuseSvgIcon>
      </IconButton>
    </div>
    </Tooltip>
  );
}